export default "__VITE_ASSET__CXe7mMUE__"